<template>
  <fragment>
    <mc-app-header title="Groups">
      <template #left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/groups/new"
          >
            Add New
          </router-link>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="groups section">
        <mc-paginated-list
          v-slot="{ items: groupList }"
          resource-state="groups"
        >
          <div v-if="groupList.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No groups available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="(group, index) in groupList"
              :key="index"
              class="groups__item box"
            >
              <div class="groups__item-details">
                <div :class="['groups__item-title']">
                  {{ group.name }}
                </div>
              </div>
              <router-link
                class="button is-link is-small"
                :to="`/groups/edit/${group.id}`"
              >
                Edit
              </router-link>
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapState } from 'vuex';

export default {};
</script>

<style lang="scss" scoped>
.groups {
  height: 100%;

  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem;
    margin-bottom: 0.5rem;
  }

  &__item-details {
    flex: 1 0 0;
    flex-direction: column;
    margin-right: 0.5rem;
  }

  &__item-title {
    &--spacing {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
